import { DataTable } from "@/components/ui/customs/data-table/data-table";
import { useGetTarifs } from "@/api/tarif.api";
import { useTarifsTableColumns } from "./tarifsTableColumns";
import { useState } from "react";
import usePagination from "@/hooks/useSyncedPagination";
import { Loader2 } from "lucide-react";
import { TarifUpdateModal } from "./tarifUpdateModal";
import { TarifReducedDto } from "@/types/api/api-types";
import { TarifDeleteModal } from "./tarifDeleteModal";
import { TarifReassignCompanyModal } from "./tarifReassignCompanyModal";

export const TarifsTable = () => {
  const { data: tarifs, isLoading } = useGetTarifs({
    isExpress: false,
  });

  const [pagination, setPagination] = usePagination("tarifs");
  const [updateTarif, setUpdateTarif] = useState<TarifReducedDto | null>(null);
  const [deleteTarif, setDeleteTarif] = useState<TarifReducedDto | null>(null);
  const [detailCompaniesTarif, setDetailCompaniesTarif] = useState<TarifReducedDto | null>(null);
  const columns = useTarifsTableColumns({
    setUpdateTarif,
    setDeleteTarif,
    setDetailCompaniesTarif,
  });

  if (isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <Loader2 className="h-4 w-4 animate-spin" />
      </div>
    );
  }

  return (
    <>
      <DataTable
        columns={columns}
        data={tarifs?.data.sort((a, b) => b._count.companies - a._count.companies) ?? []}
        pagination={pagination}
        setPagination={setPagination}
      />
      {updateTarif && (
        <TarifUpdateModal
          open={!!updateTarif}
          closeModal={() => setUpdateTarif(null)}
          tarif={updateTarif}
        />
      )}
      <TarifDeleteModal
        open={!!deleteTarif}
        closeModal={() => setDeleteTarif(null)}
        tarif={deleteTarif}
      />
      {detailCompaniesTarif && (
        <TarifReassignCompanyModal
          open={!!detailCompaniesTarif}
          closeModal={() => setDetailCompaniesTarif(null)}
          tarifId={detailCompaniesTarif?.id}
        />
      )}
    </>
  );
};
